// src/services/requestAccessAPI.js
import { createAuthHeaders } from '../../utils/authUtils';

// Base URL for Firebase Functions
const FUNCTIONS_BASE_URL = process.env.REACT_APP_FIREBASE_FUNCTIONS_BASE_URL;

/**
 * Submit access request via Firebase Function
 * @param {Object} requestData - Request data
 * @returns {Promise<Object>} - API response
 */
export const submitAccessRequest = async (requestData) => {
  try {
    console.log('API: Submitting access request');
    
    // Get authentication headers
    const headers = await createAuthHeaders();
    
    const response = await fetch(`${FUNCTIONS_BASE_URL}/submitAccessRequest`, {
      method: 'POST',
      headers,
      body: JSON.stringify(requestData)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP ${response.status}: ${response.statusText}`);
    }

    const result = await response.json();
    
    console.log('API: Access request submitted successfully', {
      requestId: result.requestId,
      success: result.success
    });
    
    return result;
    
  } catch (error) {
    console.error('API: Error submitting access request:', error);
    
    // Handle specific error cases
    if (error.message.includes('401') || error.message.includes('Unauthorized')) {
      throw new Error('אימות נכשל. אנא התחבר מחדש ונסה שוב.');
    }
    
    if (error.message.includes('403') || error.message.includes('Forbidden')) {
      throw new Error('אין לך הרשאה לשלוח בקשת גישה.');
    }
    
    if (error.message.includes('429') || error.message.includes('Too Many Requests')) {
      throw new Error('יותר מדי בקשות. אנא נסה שוב מאוחר יותר.');
    }
    
    if (error.message.includes('500') || error.message.includes('Internal Server Error')) {
      throw new Error('שגיאה בשרת. אנא נסה שוב מאוחר יותר.');
    }
    
    if (error.name === 'TypeError' || error.message.includes('fetch')) {
      throw new Error('בעיית תקשורת. בדוק את החיבור לאינטרנט ונסה שוב.');
    }
    
    // Generic error
    throw new Error(error.message || 'שגיאה בשליחת הבקשה. אנא נסה שוב.');
  }
};

/**
 * Check if user has existing access request
 * @returns {Promise<Object>} - API response
 */
export const checkExistingRequest = async () => {
  try {
    console.log('API: Checking for existing request');
    
    // Get authentication headers
    const headers = await createAuthHeaders();
    
    const response = await fetch(`${FUNCTIONS_BASE_URL}/checkAccessRequest`, {
      method: 'GET',
      headers
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP ${response.status}: ${response.statusText}`);
    }

    const result = await response.json();
    
    console.log('API: Existing request check completed', {
      hasExisting: result.hasExisting,
      requestId: result.requestId
    });
    
    return result;
    
  } catch (error) {
    console.error('API: Error checking existing request:', error);
    
    // For checking existing requests, we can be more lenient with errors
    // and just return false (no existing request found)
    return { 
      success: false, 
      hasExisting: false,
      error: error.message 
    };
  }
};